import { drawerWidth, transition, container, reportContainer } from '../../assets/styles/style';

const appStyle = (theme) => ({
  wrapper: {
    position: 'relative',
    top: '0',
    height: '100vh',
  },
  mainPanel: {
    [theme.breakpoints.up('md')]: {
      width: `calc(100% - ${drawerWidth}px)`,
    },
    overflow: 'hidden',
    position: 'relative',
    float: 'right',
    ...transition,
    maxHeight: '100%',
    width: '100%',
    overflowScrolling: 'smooth',
  },
  content: {
    marginTop: '70px',
    padding: '20px 20px',
    minHeight: 'calc(100vh - 123px)',
  },
  reportContent: {
    marginTop: '61px',
    padding: '0px',
    minHeight: 'calc(100vh - 123px)',
  },
  container,
  reportContainer,
  map: {
    marginTop: '70px',
  },
});

export default appStyle;
